import './main.css';
import { Link } from "react-scroll";
import React from 'react';
import CopyBtn from './copyBtn/copyBtn'
import creative from '../../img/main/creative.png'
import title from '../../img/main/title.svg'
import title_mob from '../../img/main/title_mob.svg'
import Running_string from '../Running_string/Running_string';

export default class Main extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            firstScreenHeight: document.documentElement.clientHeight,
        }

        this.changeScreenHeight = this.changeScreenHeight.bind(this);
    }

    changeScreenHeight() {
        this.setState({
            firstScreenHeight: document.documentElement.clientHeight
        });

        document.querySelector('.main_wrap').style.height = this.state.firstScreenHeight + 'px';
    }

    componentWillMount = () => {
        window.addEventListener("resize", this.changeScreenHeight);
        return () => window.removeEventListener("resize", this.changeScreenHeight);
    }

    componentDidMount() {
        this.changeScreenHeight();
    }

    render() {
        return (
            <div className='main_wrap'>
                <div className='main_bg'></div>
                <div className='main_grad'></div>
                <div className='container main_block'>
                    <div className='main_content main_item'>
                        <h1 className='main_title'>Angular Global Summit'23</h1>
                        <div className='main_title_img_block'>
                            <img className='main_title_img main_title_img--pc' src={title} alt="" />
                            <img className='main_title_img main_title_img--mob' src={title_mob} alt="" />
                        </div>
                        <p className='main_descr p1 grey'>Online conference for Angular users with the latest technological updates</p>
                        <p className='main_date p2 grey'>2023, February 14-15</p>
                        <div className='main_btns_wrap'>
                            <Link
                                activeClass="active"
                                to='tickets'
                                spy={true}
                                smooth={true}
                                offset={80}
                                className='main_btn button'
                            >
                                Join
                            </Link>
                            <CopyBtn />
                        </div>
                        <iframe className='main_video main_video--mob' width="400" height="230" src="https://www.youtube.com/embed/9IYU3_cerJY" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                    </div>
                    <div className='main_item--video'>
                        <iframe className='main_video main_video--pc' width="400" height="230" src="https://www.youtube.com/embed/9IYU3_cerJY" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                        <div className='main_img_block'>
                            <img className='main_creative' src={creative} alt="" />
                        </div>
                    </div>
                </div>
                <Running_string />
            </div>
        )
    }
}